export default __webpack_public_path__ + "52388a0fe97b2d759b50e2ce4a7faadf.png";